export default "__VITE_ASSET__C3y$3Se7__"